// Copyright (c) 2016 Deere & Company

import './product-status-info.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {getProductStatusClassName} from '../services/product-status';

const ProductStatusInfo = props =>

    <div className='product-status'>
        <span className='label'>
            <FormattedMessage id='STATUS'/>
        </span>
        <span className='status'>
            <span className={getProductStatusClassName(props.status)}/>
            <span>
                {props.status.value}
            </span>
        </span>
    </div>;

ProductStatusInfo.displayName = 'ProductStatusInfo';
ProductStatusInfo.propTypes = {
    status: PropTypes.instanceOf(KeyValuePair).isRequired
};

export default ProductStatusInfo;



// WEBPACK FOOTER //
// ./src/product/shared/components/product-status-info.js